<template>
  <input
    v-model="localValue"
    type="checkbox"
    :id="props.id"
    :name="props.name"
    :indeterminate="props.indeterminate"
    class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 dark:bg-gray-300"
  />
</template>
<script setup>
import { computed } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  id: String,
  name: String,
  indeterminate: Boolean,
})

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
